import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=a1b811e0&scoped=true"
import script from "./SIdentify.vue?vue&type=script&lang=js"
export * from "./SIdentify.vue?vue&type=script&lang=js"
import style0 from "./SIdentify.vue?vue&type=style&index=0&id=a1b811e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b811e0",
  null
  
)

export default component.exports